// /*!
//   _   _  ___  ____  ___ ________  _   _   _   _ ___   
//  | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
//  | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
//  |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
//  |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
// =========================================================
// * Horizon UI - v1.1.0
// =========================================================

// * Product Page: https://www.horizon-ui.com/
// * Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

// * Designed and Coded by Simmmple

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// */

// Chakra imports
import {
  Box,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
import React from "react";

export default function About() {
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Box
        bg={boxBg}
        p="30px"
        borderRadius="md"
        shadow="md"
      >
        <Text
          fontSize="md"
          color="gray.500"
          fontWeight="400"
          lineHeight="150%"
        >
          AIVRM was built by a team of University of California, Berkeley students who are completing their Master of Information and Cybersecurity.
          <br />
          <br />
          Team members:
          <br />
          <br />
          Shashank Kotturi
          <br />
          David Ian Clark
          <br />
          Jimmy Tsai (Yun-Hsi Tsai)
          <br />
          Karim Elghobashi
        </Text>
      </Box>
    </Box>
  );
}
